import React from "react";
import img from "../assets/img/no-deliveryman-assigned.svg";
const NoDeliveryManImage = () => {
	return (
		<>
			<img src={img} width={190} height={190} alt="" />
		</>
	);
};

export default NoDeliveryManImage;
